import helper from '@/libs/forms';

const getFields = () => {
  const managementFields = [
    helper.boolRadio(
      'Do you manage your own rental properties?',
      'managesProperty',
      false,
      12,
    ),
  ];
  const rentalFields = [
    helper.simpleInput(
      'number',
      'Number of rentals owned lifetime',
      '',
      'rentalOwned',
      false,
      6,
    ),
    helper.simpleInput(
      'number',
      'Number of rentals held more than one year',
      '',
      'rentalHeldMoreThanOneYear',
      false,
      6,
    ),
  ];
  return managementFields.concat(rentalFields);
};

export default {
  schema: { fields: getFields() },
  options: helper.options('real-estate-management', true),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/schemas/realStateManagementSchema.js